<script setup>
import { useRouter } from 'vue-router';
import UiEmptyState from '@/components/ui/UiEmptyState.vue';

const router = useRouter();
</script>

<template>
  <main class="not-found">
    <p class="not-found__code">404</p>
    <UiEmptyState
      icon="mdi-map-marker-question-outline"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved."
      class="not-found__card"
    >
      <v-btn color="primary" prepend-icon="mdi-home-outline" @click="router.push('/')">Back to home</v-btn>
    </UiEmptyState>
  </main>
</template>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 100vh;
  padding: 16px;
  background: var(--background);
}
.not-found__code {
  margin: 0;
  font-size: 56px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--faint-foreground);
}
.not-found__card {
  width: 100%;
  max-width: 420px;
  background: var(--card);
}
</style>
